<template>
  <button
    class="p-2 rounded-lg transition-colors"
    :class="active ? 'bg-primary text-white' : 'bg-white text-gray-600 hover:bg-gray-100'"
    @click="$emit('click')"
  >
    <Icon :name="icon" class="w-5 h-5" />
  </button>
</template>

<script setup lang="ts">
defineProps<{
  icon: string;
  active: boolean;
}>();
</script>